import React from 'react';
import { cn } from '@rocco/utils/cn';
import { Button as RoccoButton } from '@rocco/components/button';
import { ReactComponent as FiltersIcon } from '@rocco/icons/svg/filters.svg';
import { Badge } from '@rocco/components/badge';
import { DisplayMode } from '@rocco/types/enum/display-mode';

interface FiltersButtonProps {
    activeFiltersCount: number;
    displayMode: DisplayMode;
}

export const FiltersButton = React.forwardRef<
    HTMLDivElement,
    FiltersButtonProps
>((props, ref) => {
    const { activeFiltersCount, displayMode, ...rest } = props;
    const hasActiveFilters = activeFiltersCount > 0;

    return (
        <div
            {...rest}
            ref={ref}
            className={cn(
                'relative border-2 border-transparent',
                hasActiveFilters ? 'rounded-full border-gray-200' : null,
            )}
        >
            {displayMode === DisplayMode.Desktop ? (
                <FiltersButtonDesktop />
            ) : (
                <FiltersButtonMobile />
            )}

            {hasActiveFilters && (
                <div className="absolute -right-1 -top-3 z-1">
                    <Badge size="square" text="default">
                        {activeFiltersCount}
                    </Badge>
                </div>
            )}
        </div>
    );
});

FiltersButton.displayName = 'FiltersButton';

const FiltersButtonMobile = () => (
    <RoccoButton color="muted" size="square42" aria-label="Filter Button">
        <FiltersIcon className="size-4.5 fill-gray-50 text-gray-50" />
    </RoccoButton>
);

const FiltersButtonDesktop = () => (
    <RoccoButton color="primary">
        <FiltersIcon className="mr-2 size-4.5" />
        <span>Filters</span>
    </RoccoButton>
);
